export default "__VITE_ASSET__DY892Et8__"